/* WAVY-CRO-1001C: "Not all jade is equal" card carousel (sections/wavy-grade-compare.liquid).
   The track is a native scroll-snap scroller, so touch swipe needs no JS. This adds: arrow buttons that step one
   card and wrap round at either end, mouse drag on fine pointers (snap paused while dragging, settles on the
   nearest card, biased one step once the drag passes 15% of a card), and Left/Right keys on the focused track.
   Delegated from document, so sections re-rendered in the theme editor work with no init. */
(() => {
  'use strict';
  if (window.wjGradeCarousel) return;
  window.wjGradeCarousel = true;

  const TRACK = '[data-wj-gc-track]';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let suppressClick = false;

  const cards = (track) => Array.from(track.children);
  function step(track) {
    const c = cards(track);
    if (c.length < 2) return track.clientWidth;
    return c[1].offsetLeft - c[0].offsetLeft;
  }
  function index(track) {
    const s = step(track) || 1;
    return Math.round(track.scrollLeft / s);
  }
  function lastIndex(track) {
    const s = step(track) || 1;
    return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / s));
  }
  function go(track, i) {
    track.scrollTo({ left: i * step(track), behavior: reduced.matches ? 'auto' : 'smooth' });
  }
  function move(track, delta) {
    const last = lastIndex(track);
    const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    const cur = atEnd ? last : index(track);
    let next = cur + delta;
    if (next > last) next = 0;       // wrap: past the last card, back to the first
    if (next < 0) next = last;       // and from the first, round to the last
    go(track, next);
  }

  document.addEventListener('click', (event) => {
    if (suppressClick && event.target.closest && event.target.closest(TRACK)) {
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const btn = event.target.closest && event.target.closest('[data-wj-gc-step]');
    if (!btn) return;
    const root = btn.closest('[data-wj-gc]');
    const track = root && root.querySelector(TRACK);
    if (track) move(track, Number(btn.dataset.wjGcStep));
  }, true);

  document.addEventListener('keydown', (event) => {
    const track = event.target.matches && event.target.matches(TRACK) ? event.target : null;
    if (!track) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      move(track, event.key === 'ArrowRight' ? 1 : -1);
    }
  });

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const track = event.target.closest && event.target.closest(TRACK);
    if (!track) return;
    const startX = event.clientX;
    const startLeft = track.scrollLeft;
    let dragging = false;
    const onMove = (e) => {
      const dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < 6) return;
        dragging = true;
        track.classList.add('is-dragging');
      }
      track.scrollLeft = startLeft - dx;
    };
    const onEnd = (e) => {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onEnd);
      window.removeEventListener('pointercancel', onEnd);
      if (!dragging) return;
      suppressClick = e.type === 'pointerup';
      setTimeout(() => { suppressClick = false; }, 0);
      track.classList.remove('is-dragging');
      const s = step(track) || 1;
      const dx = e.clientX - startX;
      let target = Math.round(startLeft / s);
      if (Math.abs(dx) > s * 0.15) target += dx < 0 ? 1 : -1;
      go(track, Math.max(0, Math.min(lastIndex(track), target)));
    };
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onEnd);
    window.addEventListener('pointercancel', onEnd);
  });

  // Hide the arrows (and the grab cursor) when every card already fits: there is nothing to rotate through.
  function fit(root) {
    (root && root.querySelectorAll ? root : document).querySelectorAll('[data-wj-gc]').forEach((sec) => {
      const track = sec.querySelector(TRACK);
      if (track) sec.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 2);
    });
  }
  let fitTimer = 0;
  window.addEventListener('resize', () => { clearTimeout(fitTimer); fitTimer = setTimeout(() => fit(), 150); });
  window.addEventListener('load', () => fit());
  document.addEventListener('shopify:section:load', (event) => fit(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => fit());
  else fit();

  document.addEventListener('dragstart', (event) => {
    if (event.target.closest && event.target.closest(TRACK)) event.preventDefault();
  });
})();
